import Badge from './Badge';

export type StatusVariant = 'success' | 'warning' | 'error' | 'info';

interface StatusBadgeProps {
  status: string;
  statusMapping: Record<string, string>;
  className?: string;
}

export const getStatusVariant = (status: string): StatusVariant => {
  const normalizedStatus = status.toLowerCase();
  
  if (['completed', 'working', 'confirmed', 'active'].includes(normalizedStatus)) {
    return 'success';
  }
  
  if (['starting', 'created', 'in_progress'].includes(normalizedStatus)) {
    return 'info';
  }
  
  if (['pending', 'scan_qr_code', 'rescheduled', 'restarting'].includes(normalizedStatus)) {
    return 'warning';
  }
  
  if (['canceled', 'stopped', 'expired', 'failed', 'inactive'].includes(normalizedStatus)) {
    return 'error';
  }
  
  return 'info';
};

function StatusBadge({ status, statusMapping, className }: StatusBadgeProps) {
  const normalizedStatus = status?.toLowerCase() || '';
  const displayText = statusMapping[normalizedStatus] || status;
  const variant = getStatusVariant(normalizedStatus);
  
  return (
    <Badge variant={variant} className={className}>
      {displayText}
    </Badge>
  );
}

export default StatusBadge;